module.exports = __webpack_public_path__ + "static/media/icon_user.309abc09.svg";